'use client'

import { BurgerIcon } from '@/components/icons/BurgerIcon'

interface IBurgerButtonProps {
  onClick: () => void
}

export function BurgerButton({ onClick }: IBurgerButtonProps) {
  return (
    <button
      aria-label="Mobile menu"
      className="flex h-10 w-10 cursor-pointer flex-col items-center justify-center gap-1 rounded-full bg-[#F4F4F4]"
      onClick={onClick}
    >
      <BurgerIcon size="26px" />
    </button>
  )
}
